import { combineReducers } from 'redux';

import SwarmConfigDataReducer from './reducerSwarmConfigData';
import UIStateReducer from './reducerUIState';
import AppReadyReducer from './reducerAppReady';
import TerminalReducer from './reducerTerminal';
import UserReducer from './reducerUser';

export const createReducers = (store, geoData) => ({
  appReady: AppReadyReducer, // application bootstrap state
  user: UserReducer, // user data
  swarmConfigData: SwarmConfigDataReducer, // config data loaded from swarm (partner , currencies)
  uiState: UIStateReducer, // ui state (not saved)
  terminal: TerminalReducer,
});

export const combine = (geoData) => combineReducers(createReducers(geoData));

export default combine();
